import React, { useState, useContext } from "react";
import {
    Box,
    Grid,
    Typography,
    TextField,
    Checkbox,
    FormControlLabel,
    Card,
    Tabs,
    Tab,
    CircularProgress,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate, Link } from "react-router-dom";
// Assets
import Logo from "../assets/images/spirnexs-logo-white.webp";
import BgImage from "../assets/images/AerialViewContainer.svg";
// Components
import CustomButton from "../components/common/CustomButton";
import CustomTextField from "../components/common/CustomTextField";
import CustomPasswordFeild from "../components/common/CustomPasswordFeild";
import MessageBox from "../components/common/CustomMessageBox";
import Register from "../components/AuthPages/Register";
// Services
import { genericPost } from "../services/authServices";
import {
    LOGIN_PATH,
    FORGOT_PASSWORD,
    VERIFY_MAIL,
} from "../services/apiRoutes";
// Context
import { AuthContext } from "../context/AuthContext";

const loginSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
});
const SignInPage = () => {
    const { login } = useContext(AuthContext)
    const [tabValue, setTabValue] = useState('login');
    const [forgotPassword, setForgotPassword] = useState(false)
    const [linkSent, setLinkSent] = useState(false)
    const [email, setEmail] = useState('')
    const [verifyEmail, setVerifyemail] = useState(false)
    const [otpSubmitting, setOtpSubmitting] = useState(false);

    const [verifyCode, setVerifyCode] = useState({
        userIdToken: '',
        otp: ''
    })
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    // Handle tab change
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const navigate = useNavigate()
    // Handle form submission
    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = await genericPost(LOGIN_PATH, values);
            if (response.status == 200 && response?.data?.accessToken) {
                setVerifyCode((prev) => ({
                    ...prev,
                    userIdToken: response.data.accessToken
                }))
                setVerifyemail(true)
                // let accessToken = response.data.accessToken
                // let authUser = response.data.authUser && JSON.stringify(response.data.authUser)
                // sessionStorage.setItem('authUser', authUser)
                // sessionStorage.setItem('accessToken', accessToken)
                // sessionStorage.setItem('userData', JSON.stringify(response.data))

                // login(accessToken)
                // setTimeout(() => {
                //     if (response.data.firstTimeLogin) {
                //         navigate('/add/company')
                //     } else if (response.data.isSetupDone == false) {
                //         navigate('/subscription')
                //     } else {
                //         navigate('/app/dashboard')
                //     }
                // }, 1500)
            } else {
                let errorMessage = response.error.message
                setMessage({
                    open: true,
                    text: errorMessage || 'Something went wrong',
                    type: 'error'
                })
            }
        } catch (error) {
            setMessage({
                open: true,
                text: 'Something went wrong',
                type: 'error'
            })
        } finally {
            // setSubmitting(false);
        }
    };
    const handleResetPassword = async () => {
        const payload = {
            email: email
        }
        try {
            const response = await genericPost(FORGOT_PASSWORD, payload);
            if (response.status == 200) {
                setMessage({
                    open: true,
                    text: "Mail sent successfully",
                    type: "success",
                });
                setLinkSent(true)
            } else {
                let errorMessage = response.error.message;
                setMessage({
                    open: true,
                    text: errorMessage || "Something went wrong",
                    type: "error",
                });
            }
        } catch (error) {
            setMessage({
                open: true,
                text: "Something went wrong",
                type: "error",
            });
        } finally {
            // setSubmitting(false);
        }
    }
    const ReturnTologin = () => {
        setLinkSent(false)
        setForgotPassword(false)
    }
    const handleVerifyOtp = async () => {
        setOtpSubmitting(true);   // show spinner
        try {
            const response = await genericPost(VERIFY_MAIL, verifyCode);
            if (response.status == 200) {

                let accessToken = response.data.accessToken
                let authUser = response.data.authUser && JSON.stringify(response.data.authUser)
                sessionStorage.setItem('authUser', authUser)
                sessionStorage.setItem('accessToken', accessToken)
                sessionStorage.setItem('userData', JSON.stringify(response.data))
                login(accessToken)
                setTimeout(() => {

                    if (response.data.firstTimeLogin) {
                        navigate('/add/company')
                        // } else if (response.data.isSetupDone == false) {
                    } else if (response.data.isSetupDone == false, response.data.subcriptionActive == false) {
                        navigate('/subscription')
                    } else {
                        navigate('/app/dashboard')
                    }
                }, 1500)
            } else {
                let errorMessage = response.error.message
                setMessage({
                    open: true,
                    text: errorMessage || 'Something went wrong',
                    type: 'error'
                })
            }
        } catch (error) {
            setMessage({
                open: true,
                text: 'Something went wrong',
                type: 'error'
            })
        } finally {
            setOtpSubmitting(false);
        }
    };


    return (
        <Box sx={styles.page}>
            {/* BACKGROUND IMAGE */}
            <Box sx={styles.overlayImage} />

            {/* HEADER */}
            <Box sx={styles.header}>
                <img src={Logo} alt="logo" style={{ height: 40 }} />
            </Box>

            {/* MAIN */}
            <Grid container sx={styles.mainContainer}>
                {/* LEFT SIDE */}
                <Grid item md={6} xs={12} sx={styles.leftPanel}>
                    <Typography sx={styles.headingLine}>Connecting</Typography>
                    <Typography sx={styles.headingLine}>Markets</Typography>
                    <Typography sx={{ ...styles.headingLine, fontWeight: 800 }}>
                        Across
                    </Typography>
                    <Typography sx={{ ...styles.headingLine, fontWeight: 800 }}>
                        Borders
                    </Typography>
                </Grid>

                {/* RIGHT SIDE */}
                <Grid item md={6} xs={12} sx={styles.rightPanel}>
                    {/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@caed start */}

                    <Card
                        variant="outlined"
                        sx={{
                            ...styles.glassCard,
                        }}
                    >
                        <Box sx={{ width: "100%" }}>

                            <Formik
                                initialValues={{ email: '', password: '' }}
                                validationSchema={loginSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ isSubmitting }) => (
                                    <Form>

                                        {/* TITLE */}
                                        {!forgotPassword && !verifyEmail && (
                                            <Typography sx={styles.formTitle}>
                                                Login
                                            </Typography>
                                        )}

                                        {/* ================= FORGOT PASSWORD ================= */}
                                        {forgotPassword ? (
                                            <Box>

                                                {!linkSent ? (
                                                    <>


                                                        <>
                                                            {/* ===== Heading Section ===== */}
                                                            <Box
                                                                sx={{
                                                                    mb: 4,
                                                                    mt: 2,
                                                                    textAlign: "center",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        color: "#ffffff",
                                                                        fontWeight: 600,
                                                                        fontSize: "22px",
                                                                        mb: 1,
                                                                        textAlign: "center"
                                                                    }}
                                                                >
                                                                    Forgot your password?
                                                                </Typography>

                                                                <Typography
                                                                    sx={{
                                                                        color: "#4da6ff",
                                                                        fontWeight: 700,
                                                                        fontSize: "26px",
                                                                        mb: 2,
                                                                        textAlign: "center"
                                                                    }}
                                                                >
                                                                    No worries!
                                                                </Typography>

                                                                <Typography
                                                                    sx={{
                                                                        color: "#ffffff",
                                                                        fontWeight: 300,
                                                                        fontSize: "14px",
                                                                        lineHeight: 1.6,
                                                                        maxWidth: "420px",
                                                                        textAlign: "center"
                                                                    }}
                                                                >
                                                                    Enter your registered email address and we’ll send you a link to reset your password.
                                                                </Typography>
                                                            </Box>

                                                            {/* ===== Email Field ===== */}
                                                            <Box
                                                                sx={{
                                                                    mt: 4,
                                                                    display: "flex",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                <Box sx={{ width: "100%", maxWidth: "420px" }}>
                                                                    <CustomTextField
                                                                        type="text"
                                                                        placeholder="Enter Email"
                                                                        fullWidth
                                                                        value={email}
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                        sx={{
                                                                            ...textFieldStyle,
                                                                            mb: 3
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Box>

                                                            {/* ===== Button ===== */}
                                                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                <Box sx={{ width: "100%", maxWidth: "420px" }}>
                                                                    <CustomButton
                                                                        variant="contained"
                                                                        title="Send password reset link"
                                                                        sx={{
                                                                            ...styles.button,
                                                                            mt: 2,
                                                                            py: 1.5,
                                                                            fontSize: "14px",
                                                                            fontWeight: 500
                                                                        }}
                                                                        onClick={handleResetPassword}
                                                                    />
                                                                </Box>
                                                            </Box>

                                                            {/* ===== Back to Login ===== */}
                                                            <Typography sx={{ mt: 3, textAlign: "center" }}>
                                                                <Link
                                                                    onClick={ReturnTologin}
                                                                    style={{
                                                                        color: "#ffffff",
                                                                        textDecoration: "none",
                                                                        cursor: "pointer",
                                                                        fontWeight: 300,
                                                                        fontSize: "13px"
                                                                    }}
                                                                    onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                                                                    onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                                                                >
                                                                    Return to login
                                                                </Link>
                                                            </Typography>
                                                        </>
                                                    </>
                                                ) : (

                                                    <Box sx={{ textAlign: "center", px: 2 }}>
                                                        {/* GMAIL ICON */}
                                                        <Box
                                                            component="img"
                                                            src="https://cdn-icons-png.flaticon.com/512/281/281769.png"
                                                            alt="gmail"
                                                            sx={{
                                                                width: 70,
                                                                height: 70,
                                                                mb: 2,
                                                            }}
                                                        />

                                                        {/* TITLE */}
                                                        <Typography
                                                            sx={{
                                                                fontSize: "22px",
                                                                fontWeight: 300,
                                                                color: "#fff",
                                                                mb: 1,
                                                            }}
                                                        >
                                                            Check your email!
                                                        </Typography>

                                                        {/* DESCRIPTION */}
                                                        <Typography
                                                            sx={{
                                                                fontSize: "10px",
                                                                color: "#e0e0e0",
                                                                mb: 3,
                                                                fontWeight: 300,
                                                            }}
                                                        >
                                                            We’ve sent a password reset link to your registered email address.
                                                            Click the link in the email to securely reset your password and
                                                            regain access to your account.
                                                        </Typography>

                                                        {/* BUTTON */}
                                                        <CustomButton
                                                            title="Return to login"
                                                            sx={styles.button}
                                                            onClick={ReturnTologin}
                                                        />
                                                    </Box>
                                                )}
                                            </Box>
                                        ) : !verifyEmail ? (

                                            <>
                                                {/* EMAIL */}
                                                <Typography sx={styles.label}>
                                                    Email address
                                                </Typography>

                                                <Field
                                                    as={CustomTextField}
                                                    name='email'
                                                    placeholder="name@gmail.com"
                                                    fullWidth
                                                    sx={textFieldStyle}
                                                />
                                                <ErrorMessage name="email" component="div" style={styles.error} />

                                                {/* PASSWORD */}
                                                <Typography sx={{ ...styles.label, mt: 2 }}>
                                                    Password
                                                </Typography>

                                                <Field
                                                    as={CustomPasswordFeild}
                                                    name='password'
                                                    placeholder="**************"
                                                    fullWidth
                                                    sx={textFieldStyle}
                                                />
                                                <ErrorMessage name="password" component="div" style={styles.error} />

                                                {/* OPTIONS */}
                                                <Box sx={styles.optionRow}>
                                                    <FormControlLabel
                                                        control={<Checkbox sx={{ color: "#fff" }} />}
                                                        label={
                                                            <Typography sx={styles.optionText}>
                                                                Remember Password
                                                            </Typography>
                                                        }
                                                    />

                                                    <Typography
                                                        sx={styles.resetText}
                                                        onClick={() => setForgotPassword(true)}
                                                    >
                                                        Forgot Password ?
                                                    </Typography>
                                                </Box>

                                                {/* BUTTON */}
                                                <CustomButton
                                                    type="submit"
                                                    sx={styles.buttonLogin}
                                                    title={
                                                        isSubmitting ? (
                                                            <>
                                                                <CircularProgress size={20} color="inherit" />
                                                                <span style={{ marginLeft: 10 }}>Login</span>
                                                            </>
                                                        ) : "Login"
                                                    }
                                                />
                                            </>
                                        ) : (

                                            <>
                                                {/* OTP */}
                                                <Typography sx={styles.label}>
                                                    Enter OTP
                                                </Typography>

                                                <CustomTextField
                                                    placeholder="Enter OTP"
                                                    fullWidth
                                                    value={verifyCode.otp}
                                                    onChange={(e) =>
                                                        setVerifyCode(prev => ({
                                                            ...prev,
                                                            otp: e.target.value
                                                        }))
                                                    }
                                                    sx={textFieldStyle}
                                                />

                                                <CustomButton
                                                    sx={styles.button}
                                                    onClick={handleVerifyOtp}
                                                    title={
                                                        otpSubmitting ? (
                                                            <>
                                                                <CircularProgress size={20} color="inherit" />
                                                                <span style={{ marginLeft: 10 }}>
                                                                    Verifying...
                                                                </span>
                                                            </>
                                                        ) : "Verify OTP"
                                                    }
                                                />
                                            </>
                                        )}
                                    </Form>
                                )}
                            </Formik>
                            <Typography sx={styles.signupText}>
                                Don’t have an account ?{" "}
                                {/* <span style={styles.signupLink}>Sign up</span> */}
                                <span
                                    style={styles.signupLink}
                                    onClick={() => navigate("/signup")}
                                >
                                    Sign up
                                </span>


                            </Typography>
                        </Box>
                    </Card>
                    {/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@caed end */}

                </Grid>
            </Grid>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                type={message.type}
            />
        </Box>
    );
};

export default SignInPage;

//////////////////////////////////////////////////////// 🎨 STYLES
////////////////////////////////////////////////////////

const styles = {
    // @@@@@@@@@@@@@@@@@@@@@@@@@@
    error: {
        color: "#ff4d4f",
        fontSize: "12px",
    },

    page: {
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        background:
            "linear-gradient(120deg, #0A1FB8 0%, #3A0CA3 50%, #7209B7 100%)",
        overflow: "hidden",
    },

    overlayImage: {
        position: "absolute",
        inset: 0,
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.25,
        filter: "blur(2px)",
        zIndex: 0,
    },

    header: {
        position: "absolute",
        top: 20,
        left: 30,
        zIndex: 2,
    },

    mainContainer: {
        minHeight: "100vh",
        alignItems: "center",
        maxWidth: "1300px",
        margin: "auto",
        position: "relative",
        zIndex: 2,
    },

    //////////////////////////////////////////
    // LEFT SIDE
    //////////////////////////////////////////
    leftPanel: {
        color: "#fff",
        paddingLeft: { md: "60px" },
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "center",
    },

    headingLine: {
        fontSize: "64px",
        fontWeight: 500,
        lineHeight: 1.1,
        letterSpacing: "0.5px",
    },

    //////////////////////////////////////////
    // RIGHT SIDE
    //////////////////////////////////////////
    rightPanel: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: "20px", md: "0" },
    },

    glassCard: {
        width: "100%",
        maxWidth: "420px",
        padding: "35px",
        borderRadius: "20px",
        backdropFilter: "blur(20px)",
        background: "rgba(255,255,255,0.15)",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        color: "#fff",
    },

    formTitle: {
        fontSize: "24px",
        fontWeight: 700,
        marginBottom: "20px",
    },

    label: {
        fontSize: "14px",
        marginBottom: "6px",
        opacity: 0.9,
    },

    optionRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "10px",
    },

    optionText: {
        fontSize: "13px",
        color: "#fff",
    },

    resetText: {
        fontSize: "13px",
        cursor: "pointer",
        opacity: 0.9,
        "&:hover": {
            textDecoration: "underline",
        },
    },

    button: {
        width: "100%",
        height: "48px",
        marginTop: "20px",
        borderRadius: "10px",
        background: "#2F54EB",
        textTransform: "none",
        fontSize: "15px",
        fontWeight: 600,
        "&:hover": {
            background: "#1d39c4",
        },
    },

    buttonLogin: {
        height: "48px",
        marginTop: "20px",
        borderRadius: "10px",
        background: "linear-gradient(90deg, #2649F1 0%, #0851A4 100%)",
        textTransform: "none",
        fontSize: "15px",
        fontWeight: 300,
        color: "#fff",
        px: "30px",
        border: "none !important",
        outline: "none !important",
        boxShadow: "none !important",
        "&:hover": {
            background: "linear-gradient(90deg, #1f3ed6 0%, #063f82 100%)",
            border: "none !important",
            boxShadow: "none !important",
        },
    },

    signupText: {
        marginTop: "15px",
        fontSize: "13px",
        textAlign: "left",
    },

    signupLink: {
        textDecoration: "underline",
        cursor: "pointer",
        fontWeight: 500,
    },
};

////////////////////////////////////////////////////////
// TEXTFIELD STYLE
////////////////////////////////////////////////////////
const textFieldStyle = {
    mb: 2,
    backgroundColor: "#fff",

    "& .MuiOutlinedInput-root": {
        borderRadius: "8px",

        "& fieldset": {
            borderColor: "#fff",
        },
        "&:hover fieldset": {
            borderColor: "#fff",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#fff",
        },
    },

    "& input::placeholder": {
        color: "gray",
        opacity: 1,
    },
};
